import { IEmailModel } from "./email-model";

export interface IEmailModelListResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailModel[]
    }
}
